import React from 'react';

const HyperlinkContainer = props => {
  const { getAllClasses, elementStyle, element, ...rest } = props;
  const { type = 'default' } = element.data || {};

  const { formItemSettings, formSettings } = element.data || {};
  const { text, fontSize, url, disabled } = formItemSettings;
  
  const hyperlinkStyle = disabled ? {
    fontSize: `${fontSize}px`,
    pointerEvents: 'none',
  } : {
    fontSize: `${fontSize}px`,
  }

  return (
    <div
      style={elementStyle}
      className={getAllClasses(
        'webiny-pb-page-element-button',
        'webiny-pb-page-element-button--' + type
      )}
      {...formSettings}
    >
      <a href={url} style={{ ...hyperlinkStyle }} {...rest}>{text}</a>
    </div>
  );
};

export default HyperlinkContainer;
